<template>
  <div>
    <TDialog
      :visible="isOpen"
      title="Report Thyme Box Issue"
      :size="DialogSize.MD"
      @close="close"
    >
      <div class="pb-3">
        <TWarningBanner :show-dev-warning="false" />
      </div>

      <VForm
        v-slot="{ setFieldValue }"
        :initial-values="dirtyValues"
        @submit="submit(dirtyValues)"
      >
        <h4>Issue Type</h4>
        <TDropdown
          :model-value="dirtyValues.issueTypeKey"
          name="issue-type"
          class="w-full mb-4"
          :options="issueTypeOptions"
          option-label="label"
          option-value="key"
          @update:model-value="(v: any) => onIssueTypeChange(v, setFieldValue)"
        />
        <template v-if="subIssueTypeOptions.length">
          <h4>Sub-Issue Type</h4>
          <TDropdown
            :model-value="dirtyValues.subIssueTypeKey"
            name="sub-issue-type"
            class="w-full mb-4"
            :options="subIssueTypeOptions"
            option-label="label"
            option-value="key"
            @update:model-value="
              (v: any) => onSubIssueTypeChange(v, setFieldValue)
            "
          />
        </template>
        <h4>Description</h4>
        <div>
          Please describe the issue you are experiencing in <b>detail</b>,
          including what you were doing in Thyme Box when the issue occurred,
          and any error messages you see.
        </div>
        <LegacyTTextarea
          v-model="dirtyValues.description"
          class="w-full mb-4"
          name="description"
          @update:model-value="(v: any) => setFieldValue('description', v)"
        />
        <div v-for="option in debugCheckboxOptions" :key="option.label">
          <TCheckbox
            v-model="dirtyValues.checkedDebugSteps[option.label]"
            :input-id="option.label"
            binary
          />
          <label :for="option.label" class="ml-2">
            {{ option.label }}
            <span v-if="option.link">
              (<a :href="option.link" target="_blank" rel="noopener"
                >instructions</a
              >)
            </span>
          </label>
        </div>
        <TMPrimaryButton
          :disabled="!canSubmit"
          :loading="isSaving"
          class="flex mt-4"
          name="submit"
          label="Submit"
        />
      </VForm>
    </TDialog>
  </div>
</template>

<script lang="ts">
import TMPrimaryButton from '@thyme/nashville/src/components/button/TMPrimaryButton.vue'
import TDialog from '@thyme/nashville/src/components/dialog/TDialog.vue'
import { Form as VForm } from 'vee-validate'
import { defineComponent } from 'vue'
import TCheckbox from '@/legacy/nashville/checkbox/TCheckbox.vue'
import TDropdown from '@/legacy/nashville/dropdown/TDropdown.vue'
import LegacyTTextarea from '@/legacy/nashville/input/LegacyTTextarea.vue'
import TWarningBanner from '@/legacy/nashville/menu/TWarningBanner/TWarningBanner.vue'

import setup from './controller'

export default defineComponent({
  components: {
    LegacyTTextarea,
    TDialog,
    TDropdown,
    TCheckbox,
    TMPrimaryButton,
    TWarningBanner,
    VForm,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  setup,
})
</script>

<style lang="scss">
.comorbidity-wrapper {
  @apply border border-nash-neutral400 rounded-lg py-6 px-4;

  &.added {
    @apply bg-nash-purple100 border-nash-purple400;
  }
}

.svg-white-override img,
.svg-white-override svg {
  filter: brightness(100);
}
</style>
